import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import { ChromePicker } from 'react-color'
import Hue from 'react-color/lib/components/hue/Hue'
import TextInput from 'new-components/inputs/text-input'

const BoxManageColor = styled(Box)(({ theme }) => ({
    width: '100%',
    backgroundColor: '#fff',
    boxShadow: '0px 10px 15px 0px rgba(31, 41, 55, 0.10), 0px 0px 6px 0px rgba(31, 41, 55, 0.05)',
    position: 'absolute',
    zIndex: 1,
    borderRadius: '8px',
    marginTop: '1px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    '.content-select-color': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        '.chrome-picker': {
            borderRadius: '4px !important',
            boxShadow: 'none !important',
            overflow: 'hidden'
        },
        '.chrome-picker div:nth-child(2)': {
            padding: '0px !important',
            '.flexbox-fix': {
                display: 'none !important'
            }
        },
        '.hue-picker ': {
            width: "100% !important",
            '.hue-horizontal': {
                borderRadius: '8px !important',
                'div div': {
                    border: '3px solid #fff',
                    backgroundColor: 'transparent !important'
                }
            }
        }
    }
}))

export type ColorManageProps = {
    color: string
    setColor: (value: string) => void
    handleChangeColor: ({ hex }: { hex: string }) => void
    onLoadMember: (search: string) => void
    memberTypes: any
    memberType: any
    handleChangeMember: (val: any) => void
}

const ColorManage = (props: ColorManageProps) => {
    const { color, setColor, handleChangeColor } = props
    const [renderColor, setRenderColor] = useState<string>('')
    useEffect(() => {
        if (color.includes('#')) setRenderColor(color.slice(1))
        else setRenderColor(color)
    }, [color])

    return (
        <BoxManageColor>
            <Box className={`content-select-color`}>
                <ChromePicker color={color} onChange={handleChangeColor} />
                <Hue color={color} onChange={handleChangeColor} />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Box sx={{ '.MuiInputBase-root': { height: '43px' } }}>{'HEX'}</Box>
                    <Box sx={{ '.MuiInputBase-input': { padding: "0 1rem 0 .4rem !important" } }}>
                        <TextInput
                            value={renderColor}
                            onChange={(e) => {
                                const newValue = e.target.value
                                setColor(`#${newValue}`)
                            }}
                            inputProps={{ startAdornment: <Box>#</Box> }}
                        />
                    </Box>
                </Box>
            </Box>
        </BoxManageColor>
    )
}

export default ColorManage